export default {
  Title: 'Tổng hợp',
  GeneralVoucher: 'Chứng từ nghiệp vụ khác',
  AccountTransfer: 'Kết chuyển tài khoản',
  Ledger: 'Sổ cái',
  RegisterVoucher: 'Chứng từ ghi sổ',
  VoucherList: 'Tổng hợp chứng từ cùng loại',
  LockLedger: 'Khóa sổ kỳ kế toán',
  CreateReport: 'Lập báo cáo tài chính',
  SubmitReportTreasury: 'Nộp báo cáo cho KBNN',
  SubmitReport: 'Nộp báo cáo lên cấp trên',
  SubmitReportList: 'Danh sách nộp báo cáo lên cấp trên',
  SendDataToBumas: 'Gửi số liệu sang MISA Bumas',
  GeneralVoucherList: 'Danh sách chứng từ nghiệp vụ khác',
  RegisterVoucherList: 'Danh sách chứng từ  ghi sổ',
  VoucherListDetail: 'Tổng hợp chứng từ cùng loại',
  VoucherListMaster: 'Danh sách Tổng hợp chứng từ cùng loại',
  SubmitReportResult: 'Kết quả báo cáo đã nộp trực tuyến',
  CreateReportList: 'Danh sách lập báo cáo tài chính',
  SystemAccounts: 'systemaccounts',
  AccountsTransfer: 'accounttransfer',
};
